
export const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5000";

export const allUsersRoute = `${apiUrl}/messaging/allusers`;
export const sendMessageRoute = `${apiUrl}/messaging/addmsg`;
export const getAllMessagesRoute = `${apiUrl}/messaging/getmsg`;
export const getAllDashboardNotification = `${apiUrl}/messaging/getAllDashboardNotification`;
export const transactionsRoute = `${apiUrl}/payment/transactions`;
export const ownersAndPackagesRoute = `${apiUrl}/user/all-owners`;